// bundle up our constants so that we have an easy-to-locate place
export const conf = {
  RWGPS_API_KEY: process.env.RWGPS_API_KEY || "RWGPS_API_KEY_FIXME",
};
